export const CARRERAS_CUC = 5;
export const TIPOS_BECAS = 18; // 17
export const ESTADOS_BECAS = 19; // 18
export const OBSERVACIONES_BECAS = 55 // 53
export const EMPRESAS_VIGENTES_BECAS = 50 // 48
export const BECA_REVISADO = 10487 // 9571 